import { render } from "./ObstetricsAndGynaecology.vue?vue&type=template&id=494ef5e9&scoped=true"
import script from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"
export * from "./ObstetricsAndGynaecology.vue?vue&type=script&lang=ts"

import "./ObstetricsAndGynaecology.vue?vue&type=style&index=0&id=494ef5e9&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-494ef5e9"

export default script